module.exports = __webpack_public_path__ + "img/firefly_helmet_001.0e035504.png";